<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-6">
          <h1 class="mt-5">My ADMs</h1>
          <div *ngIf="loadingData || !subscriptionsLoaded">
            <i class="fas fa-spinner fa-pulse"></i> Loading, Please Wait...
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4" style="margin-top: 6px">
          <a href="#" (click)="createLayout()" *ngIf="creatableSubscriptions.length > 0"><span class="fas fa-table" title="Create New Agent Data Model"></span>&nbsp;&nbsp;Create New Agent Data Model</a>
        </div>
      </div>

      <div class="row" *ngIf="isAdmin && subscriptions.length > 0" style="margin-bottom: 10px">
        <div class="col-md-12 text-muted">
          One connection for all your Agent Data Models:
          <ng-container *ngFor="let sub of subscriptions; let last = last">
            <a href="#" (click)="showSubscriptionConnectionInfo(sub)"><span class="fas fa-plug"></span>&nbsp;{{ sub.subscriptionName || sub.organizationName }}</a><span *ngIf="!last">, </span>
          </ng-container>
        </div>
      </div>

      <div class="row">
        <div class="col-md-2 mainLabel"></div>
        <div class="col-md-3 mainLabel">Name</div>
        <div class="col-md-7 mainLabel">Status</div>
      </div>
      <ng-container *ngIf="currentLayouts">
        <ng-container *ngFor="let layout of currentLayouts">
          <div class="row table-row">
            <div class="col-md-2" style="margin-top: 5px">
              <ng-container *ngIf="layout.canManage">
                <a href="#" (click)="regenerateLayout(layout.admLayoutId)"><span class="fas fa-sync" title="Regenerate"></span></a>&nbsp;
                <a href="#" (click)="editLayout(layout)"><span class="fas fa-edit" title="Edit"></span></a>&nbsp;
                <a href="#" (click)="deleteLayout(layout)"><span class="fas fa-trash" title="Delete"></span></a>&nbsp;
              </ng-container>
              <a href="#" (click)="showConnectionInfo(layout)"><span class="fas fa-plug" title="Connection Info"></span></a>&nbsp;
              <a href="#" (click)="copyLayout(layout)" *ngIf="creatableSubscriptions.length > 0"><span class="fas fa-copy" title="Copy"></span></a>
            </div>
            <div class="col-md-3">{{ layout.name }}</div>
            <div class="col-md-7"><i *ngIf="startingIds.has(layout.admLayoutId)" class="fas fa-spinner fa-pulse"></i> {{ layout.statusText }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="currentLayouts.length === 0 && !loadingData && subscriptionsLoaded">
          <div class="row">
            <div class="col-md-12">
              <ng-container *ngIf="subscriptions.length > 0">No Agent Data Models yet.</ng-container>
              <ng-container *ngIf="subscriptions.length === 0">Your subscription does not currently include Agent Data Models.</ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
